module.exports = __webpack_public_path__ + "static/img/A157.ad02eb7b.jpg";